export function fromLocaleString(str) {
  if (typeof str === 'number') {
    return str;
  }
  if (!str) {
    return 0;
  }
  return Number(str.replace(/,/g, ''));
}


export function calculateAxleTotals(axleGroups) {
  if(!axleGroups) return { left: 0, right: 0, gross: 0 }
  const totals = axleGroups?.reduce((acc, axleGroup) => {
    const { left, right } = axleGroup.axles?.reduce((totals, axle) => {
      const leftAxleWeight = fromLocaleString(axle.leftAxleWeight);
      const rightAxleWeight = fromLocaleString(axle.rightAxleWeight);
      return {
        left: totals.left + leftAxleWeight,
        right: totals.right + rightAxleWeight,
      };
    }, { left: 0, right: 0 }) ?? { left: 0, right: 0 };

    return {
      left: acc.left + left,
      right: acc.right + right,
      gross: acc.gross + left + right,
    };
  }, { left: 0, right: 0, gross: 0 });

  return totals;
}

export function findMostOverLimitAxleGroup(sizeAndWeight) {
  if(!sizeAndWeight || !sizeAndWeight?.axleGroups) return null;

  let maxOverLimit = 0;
  let mostOverLimitGroup = null;

  sizeAndWeight.axleGroups.forEach(axleGroup => {
    if(axleGroup.axleGroupLimit) {
      let totalWeight = 0;
      if(sizeAndWeight.platformWeigh) {
        totalWeight = fromLocaleString(axleGroup.weight);
      } else {
        const { gross } = calculateAxleTotals([axleGroup]);
        totalWeight = gross;
      }

      const overLimit = totalWeight - fromLocaleString(axleGroup.axleGroupLimit);
      if (overLimit > maxOverLimit) {
        maxOverLimit = overLimit;
        mostOverLimitGroup = axleGroup;
      }
    }
  });

  return mostOverLimitGroup;
}

export const returnPlatformGrossWeight = (platformWeigh, axleGroups) => {
  if(!platformWeigh || !axleGroups) return 0;

  //reducer to iterate over the sizeAndWeight.axleGroups and sum the weight value on each
  try {
    const totalWeight = axleGroups.reduce((acc, axleGroup) => {
      return acc + fromLocaleString(axleGroup.weight) || 0;
    }, 0);
    return totalWeight
  }catch(e){
    console.error('Error calculating platform gross weight', e)
    return 0;
  }
}

export const axleIndexToName = {
  0: "Steer Axle",
  1: "Second Axle",
  2: "Third Axle",
  3: "Fourth Axle",
  4: "Fifth Axle",
  5: "Sixth Axle",
  6: "Seventh Axle",
  7: "Eighth Axle",
  8: "Ninth Axle",
  9: "Tenth Axle",
  10: "Eleventh Axle",
  11: "Twelfth Axle",
  12: "Thirteenth Axle",
  13: "Fourteenth Axle",
  14: "Fifteenth Axle",
  15: "Sixteenth Axle",
  16: "Seventeenth Axle",
  17: "Eighteenth Axle",
  18: "Nineteenth Axle",
  19: "Twentieth Axle",
  20: "Twenty-first Axle",
  21: "Twenty-second Axle",
  22: "Twenty-third Axle",
  23: "Twenty-fourth Axle",
  24: "Twenty-fifth Axle",
  25: "Twenty-sixth Axle",
  26: "Twenty-seventh Axle",
  27: "Twenty-eighth Axle",
  28: "Twenty-ninth Axle",
  29: "Thirtieth Axle",
  30: "Thirty-first Axle",
  31: "Thirty-second Axle",
  32: "Thirty-third Axle",
  33: "Thirty-fourth Axle",
  34: "Thirty-fifth Axle",
  35: "Thirty-sixth Axle",
  36: "Thirty-seventh Axle",
  37: "Thirty-eighth Axle",
  38: "Thirty-ninth Axle",
  39: "Fortieth Axle",
  40: "Forty-first Axle",
  41: "Forty-second Axle",
  42: "Forty-third Axle",
  43: "Forty-fourth Axle",
  44: "Forty-fifth Axle",
  45: "Forty-sixth Axle",
  46: "Forty-seventh Axle",
  47: "Forty-eighth Axle",
  48: "Forty-ninth Axle",
  49: "Fiftieth Axle",
}

export function findWeightRestrictionViolation(tickets) {
  if(!Array.isArray(tickets)) return null;
  return tickets?.find(ticket => ticket?.ticketViolationPrototype?.ticketCategory?.name?.includes('Weight Restriction')) || null;
}
